/*
 * Copyright (c) 2022. Haodong JU
 */

import { IKDataEntity } from 'metaflow-js'
import hillo from 'hillo'
import CategoryType from './CategoryType'
import StringEntity from '../common/StringEntity'
import GlobalSettings from '@/GlobalSettings'
import IKUtils from 'innerken-js-utils'
import store from '../../store'
import { showSuccessMessage } from '@/common/utils'

const i = Boolean(GlobalSettings.isShowOnTable === '0')

export const colorList = ['#FFCDD2', '#F8BBD0', '#E1BEE7', '#D1C4E9', '#C5CAE9', '#BBDEFB', '#B3E5FC', '#B2EBF2', '#B2DFDB', '#C8E6C9', '#DCEDC8', '#F0F4C3', '#FFF9C4', '#FFECB3', '#FFE0B2', '#FFCCBC', '#D7CCC8', '#CFD8DC']

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    form: false,
    header: false,
  },
  dcImage: {
    type: IKDataEntity.Types.Image,
    formConfig: {
      required: false,
      type: {
        root: () => store.getters.rootUrl + GlobalSettings.dcImageRoot,
      },
      hint: 'standard_size_512x512', // 尺寸最好为512*512
    },
    displayName: ' ',
    header: i,
  },
  color: {
    type: IKDataEntity.Types.Color,
    default: colorList[Math.round(Math.random() * 18)],
    formConfig: {
      required: false,
    },
  },
  _langsname: {
    displayName: 'KategorieName',
    form: false,
  },
  langs: {
    displayName: 'labelName',
    type: IKDataEntity.Types.Group,
    formConfig: {
      groupName: 'labelName',
      default: GlobalSettings.supportLang,
      childLabelKey: 'lang',
      type: {},
    },
    tableConfig: {
      displayCondition: (item) => {
        return item.lang.toUpperCase() === GlobalSettings.getLang().toUpperCase()
      },
      displayChild: (key) => {
        console.log(key)
        return key === 'name'
      },
    },
    childKey: ['name', 'desc'],
    labelKey: 'lang',
    children: [StringEntity, StringEntity, StringEntity],
    header: false,
  },
  dishesCategoryTypeId: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: async () => { return (await CategoryType.getList()).filter(it => [9, 10].includes(it.id)) },
      },
      hint: 'milk_75%_as_food_description', // 在该分类的商品中，奶含量超过百分之75的可以选择食品税率，食品税率采用减免税率，一般为7%，酒水采用正常税率，一般为19%
    },
  },
  printOrder: {
    type: IKDataEntity.Types.Integer,
    required: false,
    formConfig: {
      default: 50,
      requiredNew: false,
      requiredEdit: false,
    },
  },
  categorySort: {
    type: IKDataEntity.Types.Integer,
    formConfig: {
      default: 50,
      required: false,
    },
    header: false,
  },

}

function formatItem (item) {
  item.catTypeId = item.dishesCategoryTypeId
  return item
}

const config = {

  add: function (item) {
    item.catTypeId = item.dishesCategoryTypeId
    return hillo.post('Category.php?op=add', {
      ...item,
      langs: JSON.stringify(item.langs),
    }, {
      showLoading: true,
    })
  },
  edit: function (item, showLoading = true) {
    item = formatItem(item)
    return hillo.postWithUploadFile('Category.php?op=update', {
      ...item,
      langs: JSON.stringify(item.langs),
    }, {
      showLoading: showLoading,
    })
  },
  remove: function (id) {
    return hillo.post('Category.php?op=delete', { id: id })
  },
  load: async function (filter) {
    return (await hillo.get('Category.php', filter)).content
  },
  randomColor: async function (list) {
    IKUtils.showLoading(true)
    for (const item of list) {
      item.appliedAttributeGroup = [item.attributeGroupId].flat().join(',')
      item.catTypeId = item.dishesCategoryTypeId

      item.color = colorList[Math.round(Math.random() * 18)]

      await hillo.postWithUploadFile('Category.php?op=update', {
        ...item,
        langs: JSON.stringify(item.langs),
      }, {
        showLoading: false,
      })
    }
    showSuccessMessage('OK')
  },

  removeAllColor: async function (list) {
    IKUtils.showLoading(true)
    for (const item of list) {
      item.appliedAttributeGroup = item.attributeGroupId.join(',')
      item.catTypeId = item.dishesCategoryTypeId
      item.color = '#FFFFFF'
      await hillo.postWithUploadFile('Category.php?op=update', {
        ...item,
        langs: JSON.stringify(item.langs),
      }, {
        showLoading: false,
      })
    }
    showSuccessMessage('OK')
  },

  removeCategoryImage: async function (categoryId) {
    await hillo.post('Category.php?op=removeCategoryImage', {
      ...categoryId,
    }, {
      showLoading: true,
    })
  },

}
export const res = IKDataEntity.ModelFactory(entity, config)
export default res
